module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab grid grid__all-around"
  }, [_c('div', {
    staticClass: "grid--row"
  }, _vm._l((_vm.plugins), function(plugin, pluginIdx) {
    return _c(plugin.type, {
      key: pluginIdx,
      tag: "component",
      staticClass: "grid--col tab--col",
      attrs: {
        "plugin": plugin
      }
    })
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a083b23", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a083b23","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/tab/index.vue
// module id = 532
// module chunks = 7